/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e="speechToTextButton.ariaLabel",t="speechToTextButton.title",o={[e]:"Start speech recognition",[t]:"Speech to Text Button"};exports.messages=o;exports.speechToTextAriaLabel=e;exports.speechToTextTitle=t;
